module.exports = __webpack_public_path__ + "static/media/file_blue.e66a6c39.svg";